export default {
  metaTitle: 'Dispatch Order',
  titlePage: 'Dispatch Order List',
  orderStatus: 'Order Status',
  payment: 'Payment',
  userId: 'User ID',
  account: 'Account',
  userPhone: 'User Phone',
  addrPhone: 'Addr Phone',
  so: 'SO#',
  packageSerial: 'Package Serial',
  shipOrderSerial: 'Ship Order Serial',
  sku: 'SKU#',
  listingId: 'Listing ID',
  shipPackage: 'Ship Package',
  paymentList1: 'All',
  paymentList2: 'Online',
  paymentList3: 'COD',
  paymentList4: 'Pre',
  // -------------------------
  PackageStates1: 'Pending Dispatch',
  PackageStates2: 'Pending Delivery',
  PackageStates3: 'In Delivery',
  PackageStates4: 'Closed',
  PackageStates5: 'Cancel',
  PackageStates6: 'Completed',
  PackageStates7: 'Rejected',
  PackageStates8: 'All',
  PackageStates9: 'Back',
  // -----------------------
  packageShort1: 'PendDisp',
  packageShort2: 'PendDeli',
  packageShort3: 'InDeli',
  packageShort4: 'Close',
  packageShort5: 'Cancel',
  packageShort6: 'Complete',
  packageShort7: 'Reject',
  packageShort8: 'All',
  packageShort9: 'Back',
  // -------------------------------
  dates1: 'Yesterday',
  dates2: 'Today',
  dates3: 'Within 7 days',
  dates4: 'Within 30 days',
  dates5: 'Within 3 months',
  dates6: 'Within 1 year',
  dates7: 'All',
  // -----------------注：下方数据为上面的简写
  dateShort1: 'Yes.',
  dateShort2: 'Tod.',
  dateShort3: '7D',
  dateShort4: '30D',
  dateShort5: '3M',
  dateShort6: '1Y',
  dateShort7: 'All',
  // -------------------
  orderconditions1: 'Creat Time',
  orderconditions2: 'Package Time',
  orderconditions3: 'Complete Time',
  orderconditions4: 'Close Time',
  // -----------------------------
  storeIdMap1: 'TopSelective',
  storeIdMap2: 'FlyingGoods',
  storeIdMap3: 'Cost-effective',
  storeIdMap4: 'FashionMall',
  storeIdMap5: 'Digitone',
  storeIdMap6: 'FlashSK',
  // --------------------------
  paymentMethodMap1: 'Online',
  paymentMethodMap2: 'COD',
  paymentMethodMap3: 'pre',
  // -----------------------------
  packageStatusMap1: 'Pending Dispatch',
  packageStatusMap2: 'In Transit',
  packageStatusMap3: 'In Delivery',
  packageStatusMap4: 'Completed',
  packageStatusMap5: 'In Delivery',
  packageStatusMap6: 'Rejected',
  packageStatusMap7: 'Cancel',
  packageStatusMap8: 'Back',
  // -----------------------------
  columnShipPackage1: 'Ship Package',
  columnShipPackage2: 'SHO Contain',
  columnShipPackage3: 'SO#',
  columnShipPackage4: 'Payment',
  columnShipPackage5: 'CreateTime',
  columnShipPackage6: 'User ID',
  columnShipPackage7: 'Due',
  columnShipPackage8: 'Online Pay',
  columnShipPackage9: 'Status',
  columnShipPackage10: 'Print Time',
  columnShipPackage11: 'Logistics No.',
  // --------------------------------------
  columnsFile1: 'Store',
  columnsFile2: 'Contact Phone',
  shippackagelist: 'shippackagelist',
  // ---------批量填写国内运单-----------
  batchselection: 'Select to fill domestic waybill number in ',
  fillInBatches: 'Batch Fill',
  printBatches: 'Batch Print Waybill',
  waybillTitle1: 'Fill in the domestic waybill in bulk for the selected',
  waybillTitle2: 'orders',
  assign: 'Fill in the domestic waybill number in bulk',
  location: 'Location',
  warehousesName: 'Warehouses Name',
  contact: 'Contact',
  phone: 'Phone',
  address: 'Address',
  batchFillIn: 'Fill in batches',
  errTips: 'Please select the logistics company and fill in the waybill number',
  waybillNumber: 'waybill number',
  editwaybill: 'Modify waybill information',
  submit: 'Confirm delivery'
}
